import * as React from "react";
import Loading, { LoadingBall } from "@ingka/loading";
import styled from "styled-components";
import { LoadingWrapper } from "../styles";

const LoadergWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100vh;
`;

const FlaggaLoader: React.FC<{ loadingText: string }> = ({ loadingText }) => (
	<Loading text={loadingText}>
		<LoadingBall size="large" color="emphasised" />
	</Loading>
);

export const LoadingComponent: React.FC<{ loadingText: string }> = ({ loadingText }) => (
	<LoadingWrapper>
		<FlaggaLoader loadingText={loadingText} />
	</LoadingWrapper>
);

const LoadingLayout: React.FC<{ text?: string }> = ({ text }) => {
	const loadingText = text || "Loading...";
	return (
		<LoadergWrapper>
			<LoadingComponent loadingText={loadingText} />
		</LoadergWrapper>
	);
};

export default LoadingLayout;
